import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { joinGroupOrContactLink, hasGroupInvite } from "@/lib/whatsapp";

const HIDE_ON_PATHS = ["/login", "/register", "/reset-password", "/forgot-password"];

export default function WhatsAppFloating() {
  const { pathname } = useLocation();
  if (HIDE_ON_PATHS.some((p) => pathname.startsWith(p))) return null;

  const tooltip = hasGroupInvite() ? "Unirme al grupo Colega Link" : "Hablar con Colega Link por WhatsApp";

  return (
    <a
      href={joinGroupOrContactLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating"
      className="fixed bottom-5 right-5 z-40 group inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-4 py-3 rounded-full shadow-2xl transition-all hover:scale-105"
      style={{ boxShadow: "0 8px 24px rgba(37, 211, 102, 0.35)" }}
      aria-label={tooltip}
      title={tooltip}
    >
      <MessageCircle size={18} className="shrink-0" />
      <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-300 rounded-full animate-ping opacity-75" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full" />
    </a>
  );
}
